export default __webpack_public_path__ + "static/media/search.75844eae.svg";